// extracted by mini-css-extract-plugin
export default {"buttons":"data_buttons__m7Euv","button":"data_button__0opI-"};